import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageComponent } from '@/components/Image';

import { ScTopSection } from './styled';

interface TopSectionProps {
  bg: string;
  leftImg: string;
  leftDecorImg: string;
  rightImg: string;
  rightDecorImg: string;
  mobImg: string;
}

export const TopSection: FC<PropsWithChildren<TopSectionProps>> = ({
  bg,
  leftImg,
  leftDecorImg,
  rightImg,
  rightDecorImg,
  mobImg,
  children,
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <ScTopSection>
      <ImageComponent alt="bg" className="bg" fill src={bg} />

      {children}

      <ImageComponent
        alt="coins"
        className="coins"
        height={160}
        src={leftDecorImg}
        width={160}
      />
      <ImageComponent
        alt="gift"
        className="gift"
        height={200}
        src={rightDecorImg}
        width={200}
      />
      <ImageComponent
        alt="deskLeft"
        className="deskLeft"
        height={448}
        src={leftImg}
        width={320}
      />
      <ImageComponent
        alt="deskRight"
        className="deskRight"
        height={448}
        src={rightImg}
        width={320}
      />
      <ImageComponent
        alt="mob"
        className={`mob ${language.toLowerCase()}`}
        height={228}
        src={mobImg}
        width={344}
      />
    </ScTopSection>
  );
};
